export default __webpack_public_path__ + "static/media/notFound.372458c0.PNG";